// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"193":"ecec2bcc","304":"54a4f424"}[chunkId] + ".chunk.js");